import { useState } from 'react';
import { useLocation } from 'wouter';
import { routes } from '@/routes/route-constants';
import { useDeleteProduct } from '@/services/product-service';
import { useBulkReceiveStock } from '@/hooks/product/use-bulk-receive-stock';

interface UseProductActionsOptions {
  productId: string;
  productName: string;
  onSuccess?: () => void;
}

export function useProductActions(options: UseProductActionsOptions) {
  const [, setLocation] = useLocation();
  const deleteProductMutation = useDeleteProduct();
  const [showBulkReceiveModal, setShowBulkReceiveModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    setLocation(routes.product.edit(options.productId.toString()));
  };

  const handleReceiveStock = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowBulkReceiveModal(true);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteProductMutation.execute(options.productId.toString());
      if (options.onSuccess) {
        options.onSuccess();
      }
      setShowDeleteConfirm(false);
    } catch (error) {
      // Error is already handled in the service layer
      setShowDeleteConfirm(false);
    }
  };

  const { handleBulkReceiveStock } = useBulkReceiveStock({
    onSuccess: () => {
      if (options.onSuccess) {
        options.onSuccess();
      }
    },
  });

  return {
    showBulkReceiveModal,
    showDeleteConfirm,
    handleEdit,
    handleReceiveStock,
    handleDelete,
    confirmDelete,
    handleBulkReceiveStock,
    setShowBulkReceiveModal,
    setShowDeleteConfirm,
  };
}
